import React, { Fragment } from 'react';

import { compose, pure } from 'recompose';

import { conditionalRender, isLoggedInUser } from 'components/helpers/helpers';
import { isMarketsPage } from 'helpers/utils';

import { LoginSignupTab } from './login-signup-tab';
import { TotalBalance } from './totalcoindetail';

const isNotBlackListedPath = ({ isblackListedPath }) => !isblackListedPath;

const ConversionNBalance = pure(
  ({
    totalBalance,
    availableBalance,
    balances,
    history,
    openCurrencyConverterPopup,
    selectedProduct,
  }) => (
    <div
      className="col-xxl-3 col-xl-4 col-lg-4 col-md-5 col-xxs-4 coin-details mobile-height"
      data-palette="ConversionNBalance">
      <TotalBalance
        total={totalBalance}
        available={availableBalance}
        balances={balances}
        history={history}
        openCurrencyConverterPopup={openCurrencyConverterPopup}
        selectedProduct={selectedProduct}
      />
    </div>
  )
);

const showLoginSignup = props => isNotBlackListedPath(props) || isMarketsPage();

const LoginSignup = pure(props => (
  <div
    className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-xxs-4 signin-details mobile-height"
    data-palette="LoginSignup">
    <LoginSignupTab {...props} />
  </div>
));

const EmptySpaceFilledBalanceKomponent = () => (
  <div
    className="d-flex col-xxl-3 col-xl-4 col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-xxs-4 coin-details mobile-height"
    data-palette="EmptySpaceFilledBalanceKomponent" />
);

const enhance = compose(
  conditionalRender([
    { when: isLoggedInUser, then: ConversionNBalance },
    { when: showLoginSignup, then: LoginSignup },
  ])
);

export const BalanceKomponent = enhance(EmptySpaceFilledBalanceKomponent);
